import { api, Api } from '@/services/api';
import type { Chat, ChatParams, ChatRoom, WithCursor } from '@/types';

const chatEndpoints = api.injectEndpoints({
  endpoints: (builder) => ({
    listChats: builder.query<ChatRoom[], { page: number }>({
      query: (params) => ({
        url: Api.ListChats,
        params: { page: params.page },
      }),
      providesTags: ['Chats'],
    }),
    chat: builder.query<WithCursor<Chat>, ChatParams>({
      query: (params) => ({
        url: Api.Chat.replace(':id', params.id),
        params: { limit: params.limit, cursor: params.cursor },
      }),
      providesTags: (_r, _e, { id }) => [{ type: 'Chats', id }],
    }),
    sendMessage: builder.mutation<unknown, { id: string; message: string }>({
      query: (params) => ({
        url: Api.Chat.replace(':id', params.id),
        method: 'POST',
        body: { message: params.message },
      }),
      invalidatesTags: (_r, _e, { id }) => [{ type: 'Chats', id }],
    }),
  }),
});

export const { useListChatsQuery, useChatQuery, useSendMessageMutation } = chatEndpoints;
